<template>
    <div class="page-wrapper login-page">
        <Header/>
        <div class="wrapper">
            <div class="login-screen">
                <div class="eclipse">
                    <div class="vcenter-container">
                        <div class="vcenter"><img src="@/image/eclipse.png"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="content-block">
                        <div class="vcenter-container">
                            <div class="vcenter">
                                <div class="login-form">
                                    <div class="title">
                                        Забыли пароль?
                                    </div>

                                    <div class="text"
                                         v-show="!passwordSent">Введите email, указанный при регистрации
                                    </div>
                                    <div class="text successful-text"
                                         v-show="passwordSent">Новый пароль отправлен на указанный email
                                    </div>

                                    <div class="form dark-bg-form" v-show="!passwordSent">
                                        <fieldset :class="{'fieldset-error': emailNotFound || emailInvalid}">
                                            <div class="gradient-border">
                                                <div class="left"></div>
                                                <div class="right"></div>
                                                <input type="text"
                                                       autocomplete="off" required=""
                                                       name="email"
                                                       ref="email"
                                                       v-model.trim="email"
                                                       v-validate="'required|email'"
                                                       @keyup.enter="recoverPassword">
                                                <label>Email</label>
                                                <span class="error-text" v-show="emailInvalid">{{ errors.first('email') }}</span>
                                                <span class="error-text" v-show="emailNotFound">Пользователь с таким email не найден</span>
                                            </div>
                                        </fieldset>
                                        <div class="center">
                                            <button type="button"
                                                    class="button white-button successful-password-recovery"
                                                    :disabled="!inputDataValid"
                                                    @click="recoverPassword">
                                                Восстановить пароль
                                            </button>
                                        </div>
                                    </div>
                                    <div class="success-check" v-show="passwordSent">
                                        <img src="@/image/success-check.png">
                                    </div>

                                    <div class="login-dop-links">
                                        <div class="string">
                                            <router-link class="login-form-link"
                                                         :to="{name: 'Login'}">Войти</router-link>
                                        </div>
                                        <div class="string">
                                            <router-link class="login-form-link login-form-link-opacity"
                                                         :to="{name: 'Registration'}">Регистрация</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="login-screen-bg bg-animation"></div>
            </div>
        </div>
        <Footer :no-footer="true"/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import { Validator } from 'vee-validate';

    export default {
        name: "ForgotPassword",

        components: {
            Header, Footer
        },

        data() {
            return {
                email: '',
                passwordSent: false,
                emailNotFound: false
            }
        },

        watch: {
            email(val) {
                this.emailNotFound = false;
            }
        },

        mounted() {
            const dict = {
                custom: {
                    email: {
                        required: 'Введите адрес электронной почты',
                        email: 'Введите адрес электронной почты'
                    }
                }
            };
            Validator.localize('en', dict);
            this.$refs.email.focus();
        },

        computed: {
            emailInvalid() {
                return this.errors.has('email');
            },

            inputDataValid() {
                return this.email
                        && this.email.length > 0
                        && !this.emailInvalid;
            }
        },

        methods: {
            async recoverPassword() {
                if (!this.inputDataValid)
                    return;

                try {
                    await this.$store.dispatch('refreshPassword', this.email);
                    this.passwordSent = true;
                } catch(error) {
                    this.emailNotFound = true;
                }
            }
        }
    }
</script>